var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKycIncomplete = function SvgKycIncomplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4201",
    "data-name": "Rectangle 4201",
    width: 30,
    height: 30,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12374",
    "data-name": "Mask Group 12374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12464",
    "data-name": "Group 12464",
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(5)",
    fill: "none",
    stroke: "#171926",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_96",
    "data-name": "Subtraction 96",
    d: "M2.072,10.5H.053A9.829,9.829,0,0,1,0,9.5,9.773,9.773,0,0,1,10,0a10.159,10.159,0,0,1,7.824,3.59l-1.42,1.422A8.224,8.224,0,0,0,10,2,7.772,7.772,0,0,0,2,9.5a7.2,7.2,0,0,0,.072,1Z",
    transform: "translate(0 9)",
    fill: "#171926"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12463",
    "data-name": "Group 12463",
    transform: "translate(11.578 13.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32954",
    "data-name": "Path 32954",
    d: "M-23451-22229.137l4.354,4.354,6.219-6.217",
    transform: "translate(23451.002 22231)",
    fill: "none",
    stroke: "#171926",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
};
export default SvgKycIncomplete;